import {AfterViewChecked, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {BookingType, CurrencyUnitTotalType, TravellerXRefType} from "@afidium/ts-facade";
import { FareOptimisationService } from "libraries/service/fare-optimisation/fare-optimisation.service";
import {
    ECostOrRetail
} from "libraries/component/booking-information/components/booking-price-card/booking-price-card.enum";
import { finalize } from "rxjs/operators";
import { Yii } from "libraries/interfaces/Yii";
import { SavingType } from "@afidium/ts-facade/model/savingType";
import { PriceItemType } from "@afidium/ts-facade/model/priceItemType";
import {TotalPerTravellerType} from "@afidium/ts-facade/model/totalPerTravellerType";
import {PriceDetailInBookingType} from "@afidium/ts-facade/model/priceDetailInBookingType";



@Component({
    selector: 'fare-optimisation-detail',
    template: `
        <loader *ngIf="!loaded" [message]="loaderMessage"></loader>
        <div *ngIf="loaded && !error.active && optimisation">
            <div class="row">
                <div>
                    <tarifications-header [booking]="booking"
                                          [costOrRetail]="costOrRetail"
                                          [price]="optimisation.price"
                                          [showLink]="false"
                                          [useMaxHeight]="true"
                                          [showReturnBtn]="true"
                    ></tarifications-header>
                </div>
                <div>
                    <tarifications-header [booking]="booking"
                                          [offerId]="offerId"
                                          [price]="optimisation.offer.priceArray[0]"
                                          [savingPrice]="optimisation?.savingArray[0]?.cost"
                                          [costOrRetail]="costOrRetail"
                                          [differences]="optimisation.differenceArray"
                                          [showLink]="false"
                                          [useMaxHeight]="true"
                                          [showReturnBtn]="true"
                                          [tarificationPrice]="optimisation.price"
                                          [whenLastUpdated]="optimisation.whenLastUpdated"
                    ></tarifications-header>
                </div>
            </div>
            <div class="row optimisation-rows">
                <div>
                    <tarification-details-table [costOrRetail]="costOrRetail"
                                                [price]="optimisation.price"
                                                [booking]="booking"
                                                [isOriginOptimisation]="true"
                                                [suffix]="'optimisationLeft'"
                    ></tarification-details-table>
                </div>
                <div>
                    <tarification-details-table [costOrRetail]="costOrRetail"
                                                [price]="optimisation.offer.priceArray[0]"
                                                [booking]="booking"
                                                [isOriginOptimisation]="true"
                                                [differences]="optimisation.differenceArray"
                                                [saving]="saving"
                                                [suffix]="'optimisationRight'"
                    ></tarification-details-table>
                </div>
            </div>
        </div>
        <notification *ngIf="loaded && error.active" type="error">{{ error.message }}</notification>
    `,
    styles: [`
        .row {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        .row > div {
            flex: 1
        }

        .optimisation-rows {
            position: relative;
        }
    `
    ]
})
export class FareOptimisationDetailComponent implements OnChanges, AfterViewChecked {
    @Input()
    public offerId: string;

    @Input()
    public bookingSyscode: string;

    @Input()
    public booking: BookingType;

    public saving: SavingType;
    public costOrRetail: string = ECostOrRetail.cost;
    //TODO : remplace any by the correct type once facade unpadted
    public optimisation: any = null;
    public loaded: boolean = false;
    public error: {
        active: boolean,
        message: string
    } = {
        active: false,
        message: ""
    };
    public loaderMessage: string = Yii.t('wui-sasha-js', "Récupération de l'optimisation");

    constructor(
        private readonly fareOptimisationService: FareOptimisationService,
    ) {
    }

    public ngAfterViewChecked(): void {
        this.handlePriceArraySize();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.bookingSyscode && changes?.offerId?.currentValue) {
            this.loaded = false;
            this.fareOptimisationService.returnOptimisation(this.bookingSyscode, this.offerId)
                .pipe(
                    finalize((): boolean => this.loaded = true),
                )
                .subscribe({
                    //TODO : remplace any by the correct type once facade unpadted
                    next: (value: any): void => {
                        this.optimisation = value;
                        this.saving = this.optimisation?.savingArray?.find(
                            (savingItem: SavingType): PriceItemType[] => {
                                return savingItem.cost.baseArray;
                            });
                        if(this.optimisation.actionForFareOptimisation === "SPLIT" &&
                            this.optimisation?.offer?.travellerArray?.length
                        ){
                            this.fareOptimisationService
                                .filterPaxOnTarificationPrice(this.optimisation.price.cost, this.optimisation.offer.travellerArray[0].signature);
                        }
                    },
                    error: (error: Error): void => {
                        this.error.active = true;
                        this.error.message = error.message;
                    },
                });
        }
    }

    private handlePriceArraySize(): void {
        const rightElement: HTMLElement = document.getElementById(`priceTableoptimisationRight`);
        const leftElement: HTMLElement = document.getElementById(`priceTableoptimisationLeft`);
        if (leftElement?.offsetHeight && rightElement?.offsetHeight && leftElement?.offsetHeight !== rightElement?.offsetHeight) {
            if (leftElement?.offsetHeight > rightElement?.offsetHeight) {
                rightElement.style.height = `${leftElement.offsetHeight.toString()}px`;
            } else {
                leftElement.style.height = `${rightElement.offsetHeight.toString()}px`;
            }
        }
    }
}
